var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Capsule"},[_c('img',{staticClass:"Capsule__image",attrs:{"src":_vm.image}}),_c('h3',{staticClass:"Capsule__name"},[_vm._v(_vm._s(_vm.name))]),_c('p',{staticClass:"Capsule__volume"},[_vm._v(_vm._s(_vm.volume)+" ml")])])}
var staticRenderFns = []

export { render, staticRenderFns }